import { Component, OnInit } from '@angular/core';
import { Event } from '@models';
import { ConditionResult, TaskResults } from '@models/Event/TaskResult.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface EvaluateTimerEventResultsModalParams {
  event: Event;
  conditionResults: ConditionResult[];
  taskResults: TaskResults;
}

@Component({
  standalone: false,
  selector: 'app-evaluate-timer-event-results-modal',
  templateUrl: './evaluate-timer-event-results-modal.component.html',
  styleUrls: ['./evaluate-timer-event-results-modal.component.scss']
})
export class EvaluateTimerEventResultsModalComponent implements OnInit, EvaluateTimerEventResultsModalParams {
  event: Event;
  conditionResults: ConditionResult[];
  taskResults: TaskResults;
  modalDragOn: boolean = false;

  public evaluateTimerEventResultsCols = [
    {field: 'timerType', header: 'Type'},
    {field: 'timing', header: 'Timing'},
    {field: 'daysOfWeek', header: 'Days Of Week'},
    {field: 'result', header: 'Result'},
    {field: 'logic', header: ''}
  ];

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  
  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  isLastConditionResult(id: number): boolean {
    const index = this.conditionResults.findIndex(r => r.id == id);

    if (index === this.conditionResults.length - 1) {
      return true;
    }
    return false;
  }
}
